import React from 'react'
import { CustomerPill } from '~/react/employee-profile/employee-customers/CustomerPill'
import { CustomerTeamMemberType } from '~/generated/types'

export const getPillElement = (
    customerId: string,
    isExecutiveSponsor: boolean,
    isCommercialLead: boolean,
    isRdLead: boolean,
    isAccountLead: boolean,
    name: string,
    logo?: string,
    init?: boolean
) => {
    const membership = {
        customer: { customerId: customerId, name: name, logo: logo },
        customerId: +customerId,
        isExecutiveSponsor: isExecutiveSponsor,
        isCommercialLead: isCommercialLead,
        isRdLead: isRdLead,
        isAccountLead: isAccountLead,
    } as CustomerTeamMemberType
    return init ? (
        <span className={'atwho-inserted'}>
            <CustomerPill customerMembership={membership} editing={true} />
        </span>
    ) : (
        <CustomerPill customerMembership={membership} editing={true} />
    )
}
